<template>
    <div id="panel-4" class="panel">
        <div class="panel-hdr bg-danger-800 bg-success-gradient">
            <h2>
                {{ __t('LIST') }}
                <span class="fw-300">
                    <i>{{ __t('ACTION_GROUPS') }}</i>
                </span>
            </h2>
        </div>

        <div class="panel-container show pt-1 pb-1">
            <div class="panel-content">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="rounded">
                        <ul
                            v-if="worked_groups.length > 0"
                            class="nav-menu mb-sm-4 mb-md-0 rounded"
                        >
                            <li
                                v-for="group in worked_groups"
                                :key="group.id"
                            >
                                <a
                                    href="#"
                                    class="waves-effect waves-themed"
                                    :class="{ active_filter: is_active_item(group) }"
                                    @click.prevent="setActive(group)"
                                >
                                    <span class="nav-link-text color-black">
                                        <div>
                                            <div class="position-relative">
                                                {{ __t(group.title.toUpperCase()) }}

                                                <span class="small text-info">
                                                    <i
                                                        v-if="group.skeep_sync"
                                                        class="fal fa-lock"
                                                    ></i>
                                                </span>
                                            </div>
                                        </div>
                                    </span>

                                    <button
                                        type="button"
                                        class="btn btn-icon btn-sm btn-success shadow-0 rounded-circle waves-effect waves-themed"
                                        @click.prevent.stop="add_action(group.id)"
                                    >
                                        <i class="fal fa-plus"></i>
                                    </button>
                                </a>
                            </li>
                        </ul>

                        <div
                            class="filter-message js-filter-message m-0 text-left pl-4 py-3 fw-500"
                        ></div>
                    </div>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
    getterType: 'actions/getActionsStateField',
    mutationType: 'actions/updateActionsStateField',
});

export default {
    name: 'pwa_action_groups',

    data() {
        return {
            groups: [],
            is_load: true,
        };
    },

    created() {
        EventBus.$on('reload_groups', this.load_groups);
        this.load_groups();
    },

    beforeDestroy() {
        EventBus.$off('reload_groups', this.load_groups);
    },

    methods: {
        add_action(groupId) {
            EventBus.$emit('action_edit', 0, groupId);
        },

        is_active_item(item) {
            return this.active_filter_group.some(
                id => parseInt(id) === parseInt(item.id)
            );
        },

        setActive(item) {
            const itemId = parseInt(item.id);

            let selectedGroups = this.active_filter_group.map(id => parseInt(id));

            if (selectedGroups.includes(itemId)) {
                selectedGroups = selectedGroups.filter(id => id !== itemId);
            } else {
                selectedGroups.push(itemId);
            }

            EventBus.$emit('filter_select_change', {
                type: 'groups',
                value: selectedGroups,
            });
        },

        async load_groups() {
            this.groups = [];
            this.is_load = true;

            try {
                const { data } = await api.get(
                    '/internal/v1/catalog/pwa/actions/groups'
                );

                if (data.status === 'operation_success') {
                    this.groups = Array.isArray(data.data) ? data.data : [];
                } else {
                    this.groups = [];
                }
            } catch (error) {
                this.groups = [];

                const response = error.response;

                EventBus.$emit('show_toast', {
                    err: response?.data?.message || error.message,
                    type: 'danger',
                    title: response?.data?.status || 'error',
                });
            } finally {
                this.is_load = false;
            }
        },
    },

    computed: {
        ...mapFields([
            'all_filter',
            'filter',
        ]),

        active_filter_group() {
            const groups = this.filter?.groups ?? this.all_filter?.groups ?? [];

            if (Array.isArray(groups)) {
                return groups;
            }

            // На случай, если старое состояние сохранило JSON-строку.
            if (typeof groups === 'string') {
                try {
                    const parsed = JSON.parse(groups);
                    return Array.isArray(parsed) ? parsed : [];
                } catch (e) {
                    return [];
                }
            }

            return [];
        },

        worked_groups() {
            return this.groups;
        },
    },
};
</script>
